"use strict";

module.exports = require('./readable').PassThrough;